<template lang="pug">
//- .row
.col-12
  .card.shadow.mb-4
    .card-header.py-3
      h3.m-0.font-weight-bold.text-primary(v-if="!editAddress") Add Return Address
      h3.m-0.font-weight-bold.text-primary(v-else) Edit Return Address
      i.closeForm.nav-item.fas.fa-fw.fa-times(v-if="!gandalf" v-on:click="cancelAddress")
    .card-body
      form#returnAddressForm(v-on:submit.prevent="submitAddress" ref="returnAddressForm")
        //- .col-12.text-right(v-if="!gandalf")
          i.nav-item.fas.fa-fw.fa-times(v-on:click="cancelAddress")
        //- h3 Return Address
        .col-12.text-right
          span(v-on:click="clearAddress").nav-item Clear Fields
        .col-12
          label.col-12 Name
          input.col-lg-10.col-12(type="text" v-model="returnAddress.name" required placeholder="Bill Gates")
          //- .error(v-if="!$v.name.required") Field is required
          //- .error(v-if="!$v.name.minLength")
          //-   | Name must have at least {{$v.name.$params.minLength.min}} letters.
          //- tree-view(:data="$v.name", :options="{rootObjectKey: '$v.name', maxDepth: 2}")
        .col-12
          label.col-12 Sender
          input.col-lg-10.col-12(type="text" required  v-model="returnAddress.sender" placeholder="Steve Jobs")
        .col-12
          label.col-12 Company
          input.col-lg-10.col-12(type="text" v-model="returnAddress.company" required placeholder="Apple")
        .col-12
          label.col-12 website
          input.col-lg-10.col-12(type="text" v-model="returnAddress.website" required placeholder="www.apple.com")
        .col-12
          label.col-12 email
          input.col-lg-10.col-12(type="email" v-model="returnAddress.email" required placeholder="stevejobs@apple.com")
        .col-12
          label.col-12 phone
          input.col-lg-10.col-12(type="phone" v-model="returnAddress.phone"  required placeholder="123-456-7890")
        .col-12
          label.col-12(for="returnAddress") Country
          select.col-lg-10.col-12(v-model="returnAddress.countryCode" required )
            //- option(selected="true" disabled="disabled" value=null) Please select a Country      
            option(value='US' selected="true") United States
            option(value='CA') Canada
            //- option( disabled) ----
            //- option(value='AF') Afghanistan
            //- option(value='AX') Åland Islands
            //- option(value='AL') Albania
            //- option(value='DZ') Algeria
            //- option(value='AS') American Samoa
            //- option(value='AD') Andorra
            //- option(value='AO') Angola
            //- option(value='AI') Anguilla
            //- option(value='AQ') Antarctica
            //- option(value='AG') Antigua and Barbuda
            //- option(value='AR') Argentina
            //- option(value='AM') Armenia
            //- option(value='AW') Aruba
            //- option(value='AU') Australia
            //- option(value='AT') Austria
            //- option(value='AZ') Azerbaijan
            //- option(value='BS') Bahamas
            //- option(value='BH') Bahrain
            //- option(value='BD') Bangladesh
            //- option(value='BB') Barbados
            //- option(value='BY') Belarus
            //- option(value='BE') Belgium
            //- option(value='BZ') Belize
            //- option(value='BJ') Benin
            //- option(value='BM') Bermuda
            //- option(value='BT') Bhutan
            //- option(value='BO') Bolivia, Plurinational State of
            //- option(value='BQ') Bonaire, Sint Eustatius and Saba
            //- option(value='BA') Bosnia and Herzegovina
            //- option(value='BW') Botswana
            //- option(value='BV') Bouvet Island
            option(value='BR') Brazil
            //- option(value='IO') British Indian Ocean Territory
            //- option(value='BN') Brunei Darussalam
            //- option(value='BG') Bulgaria
            //- option(value='BF') Burkina Faso
            //- option(value='BI') Burundi
            //- option(value='KH') Cambodia
            //- option(value='CM') Cameroon
            //- option(value='CV') Cape Verde
            //- option(value='KY') Cayman Islands
            //- option(value='CF') Central African Republic
            //- option(value='TD') Chad
            //- option(value='CL') Chile
            //- option(value='CN') China
            //- option(value='CX') Christmas Island
            //- option(value='CC') Cocos (Keeling) Islands
            //- option(value='CO') Colombia
            //- option(value='KM') Comoros
            //- option(value='CG') Congo
            //- option(value='CD') Congo, the Democratic Republic of the
            //- option(value='CK') Cook Islands
            //- option(value='CR') Costa Rica
            //- option(value='CI') Côte d'Ivoire
            //- option(value='HR') Croatia
            //- option(value='CU') Cuba
            //- option(value='CW') Curaçao
            //- option(value='CY') Cyprus
            //- option(value='CZ') Czech Republic
            //- option(value='DK') Denmark
            //- option(value='DJ') Djibouti
            //- option(value='DM') Dominica
            //- option(value='DO') Dominican Republic
            //- option(value='EC') Ecuador
            //- option(value='EG') Egypt
            //- option(value='SV') El Salvador
            //- option(value='GQ') Equatorial Guinea
            //- option(value='ER') Eritrea
            //- option(value='EE') Estonia
            //- option(value='ET') Ethiopia
            //- option(value='FK') Falkland Islands (Malvinas)
            //- option(value='FO') Faroe Islands
            //- option(value='FJ') Fiji
            //- option(value='FI') Finland
            option(value='FR') France
            //- option(value='GF') French Guiana
            //- option(value='PF') French Polynesia
            //- option(value='TF') French Southern Territories
            //- option(value='GA') Gabon
            //- option(value='GM') Gambia
            //- option(value='GE') Georgia
            option(value='DE') Germany
            //- option(value='GH') Ghana
            //- option(value='GI') Gibraltar
            //- option(value='GR') Greece
            //- option(value='GL') Greenland
            //- option(value='GD') Grenada
            //- option(value='GP') Guadeloupe
            //- option(value='GU') Guam
            //- option(value='GT') Guatemala
            //- option(value='GG') Guernsey
            //- option(value='GN') Guinea
            //- option(value='GW') Guinea-Bissau
            //- option(value='GY') Guyana
            //- option(value='HT') Haiti
            //- option(value='HM') Heard Island and McDonald Islands
            //- option(value='VA') Holy See (Vatican City State)
            //- option(value='HN') Honduras
            //- option(value='HK') Hong Kong
            //- option(value='HU') Hungary
            //- option(value='IS') Iceland
            option(value='IN') India
            //- option(value='ID') Indonesia
            //- option(value='IR') Iran, Islamic Republic of
            //- option(value='IQ') Iraq
            //- option(value='IE') Ireland
            //- option(value='IM') Isle of Man
            //- option(value='IL') Israel
            option(value='IT') Italy
            //- option(value='JM') Jamaica
            //- option(value='JP') Japan
            //- option(value='JE') Jersey
            //- option(value='JO') Jordan
            //- option(value='KZ') Kazakhstan
            //- option(value='KE') Kenya
            //- option(value='KI') Kiribati
            //- option(value='KP') Korea, Democratic People's Republic of
            //- option(value='KR') Korea, Republic of
            //- option(value='KW') Kuwait
            //- option(value='KG') Kyrgyzstan
            //- option(value='LA') Lao People's Democratic Republic
            //- option(value='LV') Latvia
            //- option(value='LB') Lebanon
            //- option(value='LS') Lesotho
            //- option(value='LR') Liberia
            //- option(value='LY') Libya
            //- option(value='LI') Liechtenstein
            //- option(value='LT') Lithuania
            //- option(value='LU') Luxembourg
            //- option(value='MO') Macao
            //- option(value='MK') Macedonia, the former Yugoslav Republic of
            //- option(value='MG') Madagascar
            //- option(value='MW') Malawi
            //- option(value='MY') Malaysia
            //- option(value='MV') Maldives
            //- option(value='ML') Mali
            //- option(value='MT') Malta
            //- option(value='MH') Marshall Islands
            //- option(value='MQ') Martinique
            //- option(value='MR') Mauritania
            //- option(value='MU') Mauritius
            //- option(value='YT') Mayotte
            //- option(value='MX') Mexico
            //- option(value='FM') Micronesia, Federated States of
            //- option(value='MD') Moldova, Republic of
            //- option(value='MC') Monaco
            //- option(value='MN') Mongolia
            //- option(value='ME') Montenegro
            //- option(value='MS') Montserrat
            //- option(value='MA') Morocco
            //- option(value='MZ') Mozambique
            //- option(value='MM') Myanmar
            //- option(value='NA') Namibia
            //- option(value='NR') Nauru
            //- option(value='NP') Nepal
            //- option(value='NL') Netherlands
            //- option(value='NC') New Caledonia
            //- option(value='NZ') New Zealand
            //- option(value='NI') Nicaragua
            //- option(value='NE') Niger
            //- option(value='NG') Nigeria
            //- option(value='NU') Niue
            //- option(value='NF') Norfolk Island
            //- option(value='MP') Northern Mariana Islands
            //- option(value='NO') Norway
            //- option(value='OM') Oman
            //- option(value='PK') Pakistan
            //- option(value='PW') Palau
            //- option(value='PS') Palestinian Territory, Occupied
            //- option(value='PA') Panama
            //- option(value='PG') Papua New Guinea
            //- option(value='PY') Paraguay
            //- option(value='PE') Peru
            //- option(value='PH') Philippines
            //- option(value='PN') Pitcairn
            //- option(value='PL') Poland
            //- option(value='PT') Portugal
            //- option(value='PR') Puerto Rico
            //- option(value='QA') Qatar
            //- option(value='RE') Réunion
            //- option(value='RO') Romania
            //- option(value='RU') Russian Federation
            //- option(value='RW') Rwanda
            //- option(value='BL') Saint Barthélemy
            //- option(value='SH') Saint Helena, Ascension and Tristan da Cunha
            //- option(value='KN') Saint Kitts and Nevis
            //- option(value='LC') Saint Lucia
            //- option(value='MF') Saint Martin (French part)
            //- option(value='PM') Saint Pierre and Miquelon
            //- option(value='VC') Saint Vincent and the Grenadines
            //- option(value='WS') Samoa
            //- option(value='SM') San Marino
            //- option(value='ST') Sao Tome and Principe
            //- option(value='SA') Saudi Arabia
            //- option(value='SN') Senegal
            //- option(value='RS') Serbia
            //- option(value='SC') Seychelles
            //- option(value='SL') Sierra Leone
            //- option(value='SG') Singapore
            //- option(value='SX') Sint Maarten (Dutch part)
            //- option(value='SK') Slovakia
            //- option(value='SI') Slovenia
            //- option(value='SB') Solomon Islands
            //- option(value='SO') Somalia
            //- option(value='ZA') South Africa
            //- option(value='GS') South Georgia and the South Sandwich Islands
            //- option(value='SS') South Sudan
            //- option(value='ES') Spain
            //- option(value='LK') Sri Lanka
            //- option(value='SD') Sudan
            //- option(value='SR') Suriname
            //- option(value='SJ') Svalbard and Jan Mayen
            //- option(value='SZ') Swaziland
            //- option(value='SE') Sweden
            //- option(value='CH') Switzerland
            //- option(value='SY') Syrian Arab Republic
            //- option(value='TW') Taiwan, Province of China
            //- option(value='TJ') Tajikistan
            //- option(value='TZ') Tanzania, United Republic of
            //- option(value='TH') Thailand
            //- option(value='TL') Timor-Leste
            //- option(value='TG') Togo
            //- option(value='TK') Tokelau
            //- option(value='TO') Tonga
            //- option(value='TT') Trinidad and Tobago
            //- option(value='TN') Tunisia
            //- option(value='TR') Turkey
            //- option(value='TM') Turkmenistan
            //- option(value='TC') Turks and Caicos Islands
            //- option(value='TV') Tuvalu
            //- option(value='UG') Uganda
            //- option(value='UA') Ukraine
            //- option(value='AE') United Arab Emirates
            option(value='GB') United Kingdom
            //- option(value='UM') United States Minor Outlying Islands
            //- option(value='UY') Uruguay
            //- option(value='UZ') Uzbekistan
            //- option(value='VU') Vanuatu
            //- option(value='VE') Venezuela, Bolivarian Republic of
            //- option(value='VN') Viet Nam
            //- option(value='VG') Virgin Islands, British
            //- option(value='VI') Virgin Islands, U.S.
            //- option(value='WF') Wallis and Futuna
            //- option(value='EH') Western Sahara
            //- option(value='YE') Yemen
            //- option(value='ZM') Zambia
            //- option(value='ZW') Zimbabwe
        .col-12
          label.col-12(for="returnAddress") Return Address 1
          input.col-lg-10.col-12(type="text" v-model="returnAddress.address1" required placeholder="1 Infinite Loop")
        .col-12
          label.col-12(for="returnAddress") Return Address 2
          input.col-lg-10.col-12(type="text" v-model="returnAddress.address2") 
        .col-12
          label.col-12(for="returnAddress") City
          input.col-lg-10.col-12(type="text" v-model="returnAddress.city" required placeholder="Cupertino")
        .col-12
          label.col-12(for="returnAddress") Postal Code
          input.col-lg-10.col-12(type="text" v-model="returnAddress.postalCode" required placeholder="95014")
        .col-12(v-if="returnAddress.countryCode == 'US'")
          label.col-12(for="returnAddress") State
          select.col-lg-10.col-12(type="text" v-model="returnAddress.stateCode" required)
              option(selected="true" disabled="disabled" value="") Please select a State
              option(value='AL') Alabama
              option(value='AK') Alaska
              option(value='AZ') Arizona
              option(value='AR') Arkansas
              option(value='CA') California
              option(value='CO') Colorado
              option(value='CT') Connecticut
              option(value='DE') Delaware
              option(value='FL') Florida
              option(value='GA') Georgia
              option(value='HI') Hawaii
              option(value='ID') Idaho
              option(value='IL') Illinois
              option(value='IN') Indiana
              option(value='IA') Iowa
              option(value='KS') Kansas
              option(value='KY') Kentucky
              option(value='LA') Louisiana
              option(value='ME') Maine
              option(value='MD') Maryland
              option(value='MA') Massachusetts
              option(value='MI') Michigan
              option(value='MN') Minnesota
              option(value='MS') Mississippi
              option(value='MO') Missouri
              option(value='MT') Montana
              option(value='NE') Nebraska
              option(value='NV') Nevada
              option(value='NH') New Hampshire
              option(value='NJ') New Jersey
              option(value='NM') New Mexico
              option(value='NY') New York
              option(value='NC') North Carolina
              option(value='ND') North Dakota
              option(value='OH') Ohio
              option(value='OK') Oklahoma
              option(value='OR') Oregon
              option(value='PA') Pennsylvania
              option(value='RI') Rhode Island
              option(value='SC') South Carolina
              option(value='SD') South Dakota
              option(value='TN') Tennessee
              option(value='TX') Texas
              option(value='UT') Utah
              option(value='VT') Vermont
              option(value='VA') Virginia
              option(value='WA') Washington
              option(value='WV') West Virginia
              option(value='WI') Wisconsin
              option(value='WY') Wyoming
              option(value='DC') Washington D.C.

        .col-12(v-if="returnAddress.countryCode == 'CA'")
          label.col-12(for="") Province
          select.col-12( v-model="returnAddress.provinceCode" required)
            option(selected="true" disabled="disabled" value="null") Please select a Province
            option(value='AB' selected="true") Alberta
            option(value='BC') British Columbia
            option(value='MB') Manitoba
            option(value='NB') New Brunswick
            option(value='NL') Newfoundland and Labrador
            option(value='NS') Nova Scotia
            option(value='ON') Ontario
            option(value='PE') Prince Edward Island
            option(value='QC') Quebec
            option(value='SK') Saskatchewan
            option(value='NT') Northwest Territories
            option(value='NU') Nunavut
            option(value='YT') Yukon
        .col-12(v-if="returnAddress.countryCode == 'IN'")
          label(for="") State
          br
          select.col-lg-10.col-12(type="text" v-model="returnAddress.stateCode" required)
            option(selected="true" disabled="disabled" value="null") Please select a State
            option(value="AN") Andaman & Nicobar Is.
            option(value="AP") Andhra Pradesh
            option(value="AR") Arunachal Pradesh
            option(value="AS") Assam
            option(value="BR") Bihar
            option(value="CG") Chandigarh
            option(value="CH") Chhattisgarh
            option(value="DN") Dadra and Nagar Haveli
            option(value="DD") Daman and Diu
            option(value="DL") Delhi
            option(value="GA") Goa
            option(value="GJ") Gujarat
            option(value="HR") Haryana
            option(value="HP") Himachal Pradesh
            option(value="JK") Jammu and Kashmir
            option(value="JH") Jharkhand
            option(value="KA") Karnataka
            option(value="KL") Kerala
            option(value="LA") Ladakh
            option(value="LD") Lakshadweep
            option(value="MP") Madhya Pradesh
            option(value="MH") Maharashtra
            option(value="MN") Manipur
            option(value="ML") Meghalaya
            option(value="MZ") Mizoram
            option(value="NL") Nagaland
            option(value="OR") Odisha
            option(value="PY") Puducherry
            option(value="PB") Punjab
            option(value="RJ") Rajasthan
            option(value="SK") Sikkim
            option(value="TN") Tamil Nadu
            option(value="TS") Telangana
            option(value="TR") Tripura
            option(value="UP") Uttar Pradesh
            option(value="UK") Uttarakhand
            option(value="WB") West Benga
        .col-12.text-right
          button.btn.btn-primary(type="submit" v-if="this.editAddress == true") Save
          button.btn.btn-primary(type="submit" v-else) Add
</template>

<script>
import { required,minLength } from 'vuelidate/lib/validators'

export default {
  name: 'ReturnAddress',
  components: {
    
  },
  props:{
    gandalf:Boolean,
    addressInfo:Object,
    editAddress:Boolean,
  },
  data:function(){
    return{
      returnAddress:{
        countryCode:'US',
        provinceCode:'',
        stateCode:'',
        address2:'',
      },

    }
  },
  validations: {
    name: {
      required,
      minLength: minLength(4)
    },
  },
  watch:{
    returnAddress: {
      phone:{
        handler(val){      
        },
        deep:true
      },
      handler() {
        if(!this.editAddress === true){
          localStorage.setItem('returnAddress', JSON.stringify(this.returnAddress));
        }
      },
      deep: true,
    },
    phone(val){
      return this.phoneFormatted = val.replace(/[^+\d]+/g, "");
    }
  },
  methods:{
    async submitAddress(){
      var theVal = this.returnAddress.phone
      if(this.returnAddress.phone){
        this.returnAddress.phone = theVal.replace(/[^+\d]+/g, "");
      }
      // if(this.returnAddress.countryCode !== 'US'){
      //   this.returnAddress.stateCode = null;
      // }
      // if(this.returnAddress.countryCode !== 'CA'){
      //   this.returnAddress.stateCode = null;
      // }
      var vm = this;
      var bodyFormData = new FormData();
      for (let field in vm.returnAddress) {
        bodyFormData.append(`${field}`, vm.returnAddress[field]);
      }
      if(this.editAddress){
        this.flash('Saving...', 'success')
        bodyFormData.append("returnAddressId",vm.returnAddress._id);        
        var update = await this.axios.post('/rp/server/return_address/update', bodyFormData)
        if(update.data.error){
          this.$emit("addressScrollTop")
          this.flash(update.data.error.message, 'danger')
        }else{
          this.flash('Saved', 'success')
          this.$emit("closeAddress");
          this.$emit("init")
        }
      }
      else{
        this.flash('Saving...','success')
        var response = await this.axios.post('/rp/server/return_address/add', bodyFormData)
        if(response.data.error){
          this.$emit("addressScrollTop")
          this.flash(response.data.error.message, 'danger')
        }else{
          if(this.gandalf) this.$emit('nextStep')
          else{
            this.flash('Saved','success');
            this.$emit("closeAddress");
            this.$emit("init")
          }
          localStorage.removeItem('returnAddress');
        }
      }
    },
    async clearAddress(){
      this.returnAddress = null;
      this.returnAddress = {
        countryCode:'US',
        provinceCode:'',
        stateCode:'',
        address2:'',
      };
    },
    async cancelAddress(){
      this.$emit("closeAddress")
    },

  },
  mounted(){
    document.onkeydown = evt => {
      evt = evt || window.event;
      if (evt.keyCode == 27) {
        this.$emit("closeAddress");
      }
    };
    if(!this.editAddress === true){
      if (localStorage.getItem('returnAddress')) this.returnAddress = JSON.parse(localStorage.getItem('returnAddress'));
    }
    if(this.addressInfo){
      this.returnAddress = this.addressInfo
      if (!this.returnAddress.stateCode) this.returnAddress.stateCode = '';
      if (!this.returnAddress.provinceCode) this.returnAddress.provinceCode = '';
      if (this.returnAddress.address2 == 'null' ) this.returnAddress.address2 = ""
    }
  },
}
</script>
<style lang="scss" scoped>
  select{margin-bottom:20px;}
  .closeForm{
    position:absolute;
    right:20px;
    top:20px;
  }
  form{
    width:100%;
    padding:30px;
    input{
      margin-bottom:20px;
    }
    button{
      margin:20px 0;
    }
  }
  @media all and (max-width:768px){
    form{
      width:100%;
      padding:0px;
      input{
        margin-bottom:20px;
      }
      button{
        margin:20px 0;
      }
    }
  }
</style>
